<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <path
            v-if="weight === 'THIN'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.21489 3.17006L16.6249 11.5801C16.8549 11.8101 16.8549 12.1901 16.6249 12.4201L8.21489 20.8301C7.98489 21.0601 7.60489 21.0601 7.37489 20.8301C7.14489 20.6001 7.14489 20.2201 7.37489 19.9901L15.3649 12.0001L7.37489 4.01006C7.14489 3.78006 7.14489 3.40006 7.37489 3.17006C7.60489 2.94006 7.98489 2.94006 8.21489 3.17006Z"
            fill="currentColor"
        />

        <!-- REGULAR -->
        <path
            v-else-if="weight === 'REGULAR'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.42999 3.22988L16.66 11.4499C16.96 11.7499 16.96 12.2399 16.66 12.5399L8.42999 20.7699C8.12999 21.0699 7.63999 21.0699 7.33999 20.7699C7.03999 20.4699 7.03999 19.9799 7.33999 19.6799L15.02 11.9999L7.33999 4.31988C7.03999 4.01988 7.03999 3.52988 7.33999 3.22988C7.63999 2.92988 8.12999 2.92988 8.42999 3.22988Z"
            fill="currentColor"
        />

        <!-- FILL -->
        <path
            v-else
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.64509 3.27994L16.6951 11.3299C17.0651 11.6999 17.0651 12.2999 16.6951 12.6699L8.64509 20.7199C8.27509 21.0899 7.67509 21.0899 7.30509 20.7199C6.93509 20.3499 6.93509 19.7499 7.30509 19.3799L14.6851 11.9999L7.30509 4.61994C6.93509 4.24994 6.93509 3.64994 7.30509 3.27994C7.67509 2.90994 8.27509 2.90994 8.64509 3.27994Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
    export default {
        name: 'chevron-right-icon',
        props: {
            width: {
                type: [String, Number],
                default: 24,
            },
            height: {
                type: [String, Number],
                default: 24,
            },
            color: {
                type: String,
                default: 'text-black',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
